import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Abramia from "../images/david-holifield-4SLhp1olvFc-unsplash.jpg"

const SecondPage = () => (
  <Layout>
    <SEO title="Hybrid kukurice Abramia" />
    <section className="text-gray-700 body-font overflow-hidden">
      <div className="container px-5 py-24 mx-auto">
        <div className="lg:w-4/5 mx-auto flex flex-wrap">
          <div className="lg:w-1/2 w-full lg:pr-10 lg:py-6 mb-6 lg:mb-0">
            <h2 className="text-sm title-font text-gray-500 tracking-widest">
              FAO 450
            </h2>
            <h1 className="text-gray-900 text-3xl title-font font-medium mb-4">
              Abramia
            </h1>
            <div className="flex mb-4">
              <span className="flex-grow text-indigo-500 border-b-2 border-indigo-500 py-2 text-lg px-1">
                Odporúčania pre pestovateľov
              </span>
            </div>
            <p className="leading-relaxed text-justify mb-4">
              Hybrid ABRAMIA je z dôvodu plasticity a tolerancie na sucho v
              suchších podmienkach vhodný pre pestovanie na siláž prípadne
              biomasu v kukuričnej oblasti. Pre vyšší podiel šúľkov a teda aj
              vyššiu stráviteľnosť silážnej hmoty je tiež vhodný na kŕmenie
              vysokoúžitkových dojníc. Hlavné odporúčanie je využitie na siláž,
              ale je možné aj využitie na špeciálne spôsoby zberu a konzervácie
              ako sú CCM a LKS. Osivo hybridu má vyššie zrno a z toho dôvodu
              obsahuje aj viac škrobu pre rýchlejší štart porastu a jeho
              zapojenie na rozmanitých pôdach.
            </p>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ hybridu</span>
              <span className="ml-auto text-gray-900">Tc</span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ zrna</span>
              <span className="ml-auto text-gray-900">
                medzityp až konský zub
              </span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Organizácia porastu:
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">
                Pestovanie v kukuričnej oblasti na siláž
              </span>
              <span className="ml-auto text-gray-900">
                80 000 <span className="text-xs">rastlín na ha</span>
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2 mb-6">
              <span className="text-gray-500">
                Špeciálne využitie na biomasu
              </span>
              <span className="ml-auto text-gray-900">
                90 000 <span className="text-xs">rastlín na ha</span>
              </span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Hospodárske vlastnosti:
              </span>
            </div>

            <div className="flex border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vhodnosť pre pestovanie kukuričnej siláže alebo biomasy v
                    kukuričnej oblasti
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vyšší podiel dobre vyvinutých šúľkov
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vyššia stráviteľnosť silážnej hmoty
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Plasticita tiež v suchších podmienkach
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Stabilita úrody suchej hmoty siláže
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="Hybrid kukurice Abramia"
            className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
            src={Abramia}
          />
        </div>
      </div>
    </section>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výsledky štátnych odrodových pokusov v rokoch 2011 - 2012 (priemer
        lokalít):
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              Úroda suchej hmoty
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              ABRAMIA
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              PR37F73
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tr rounded-br">
              ACARRO
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 "> siláže (t/ha)</td>
            <td className="bg-gray-100 px-4 py-3 ">18,90</td>
            <td className="px-4 py-3">18,00</td>
            <td className="px-4 py-3">19,30</td>
          </tr>
          <tr>
            <td className="border-t-2 border-gray-300 bg-gray-300 px-4 py-3 rounded-bl rounded-tl">
              šúľkov (t/ha)
            </td>
            <td className="border-t-2 bg-gray-100 px-4 py-3">9,00</td>
            <td className="border-t-2 border-gray-300 bg-gray-300 px-4 py-3">
              9,00
            </td>
            <td className="border-t-2 border-gray-300  bg-gray-300 px-4 py-3 rounded-br rounded-tr">
              8,61
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výsledky zo štátnych odrodových pokusov zo suchých podmienok v roku
        2012:
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              Úroda suchej hmoty
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              ABRAMIA
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              PR37F73
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              ACARRO
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 "> siláže (t/ha)</td>
            <td className="bg-gray-100 px-4 py-3 ">13,60</td>
            <td className="px-4 py-3">13,40</td>
            <td className="px-4 py-3">13,20</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300"> šúľkov (t/ha)</td>
            <td className="bg-gray-100 px-4 py-3 ">7,20</td>
            <td className="px-4 py-3 bg-gray-300">7,39</td>
            <td className="px-4 py-3 bg-gray-300">6,76</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
)

export default SecondPage
